module.exports = __webpack_public_path__ + "img/asset_login.16bbd2ac.png";